export const DE_PSEUDO_CARE_PROVIDER_REQUEST = 'DE_PSEUDO_CARE_PROVIDER_REQUEST';

export const dePseudoCareProviderRequest = ( id, pseudonym ) => ({
    type: DE_PSEUDO_CARE_PROVIDER_REQUEST,
    payload: { id, pseudonym }
});
